import { buildApiUrl } from "../lib/api";
import { getAuthHeaders } from "./auth";

export interface CameraReference {
  fileName: string;
  url: string;
  sasUrl: string | null;
  size?: number;
  createdAt?: Date;
}

export interface CameraReferencesResponse {
  deviceId: string;
  tenantId: string;
  cameraName: string;
  references: CameraReference[];
}

/**
 * Listet alle Referenzbilder für eine Kamera
 */
export async function getCameraReferences(
  deviceId: string,
  type?: 'empty' | 'trucks'
): Promise<CameraReferencesResponse> {
  const url = type 
    ? buildApiUrl(`/api/camera-references/${deviceId}/${type}`)
    : buildApiUrl(`/api/camera-references/${deviceId}`);
  
  const response = await fetch(url, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: "Failed to load references" }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }

  return response.json();
}

/**
 * Lädt ein Referenzbild hoch
 */
export async function uploadCameraReference(
  deviceId: string,
  type: 'empty' | 'trucks',
  fileName: string,
  imageData: string,
  contentType = "image/png"
): Promise<{ success: boolean; fileName: string; url: string; sasUrl: string | null; size: number }> {
  const response = await fetch(buildApiUrl(`/api/camera-references/${deviceId}`), {
    method: "POST",
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ fileName, imageData, contentType, type }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: "Upload failed" }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }

  return response.json();
}

/**
 * Löscht ein Referenzbild
 */
export async function deleteCameraReference(
  deviceId: string,
  type: 'empty' | 'trucks',
  fileName: string
): Promise<void> {
  const url = buildApiUrl(`/api/camera-references/${deviceId}/${fileName}?type=${type}`);
  const response = await fetch(url, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: "Delete failed" }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }
}
